const regexp = {
  phone: /^1[3456789]\d{9}$/,
  uniCode: /^[A-HJ-NP-UWXY0-9]{18}$/
};

export default regexp;
